import { Link } from "react-router-dom";
import AnimationOnScroll from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import BackArrow from "../assets/images/back-arrow.svg";
import SkinScaner from "../assets/images/skin_scan.svg";

const DermaStart = () => {
  return (
    <section className="pt-2 pb-20 flex flex-col tab-screen">
      <div className="px-6">
        <div className="flex items-center mb-8 w-full relative z-50">
          <Link
            to={-1}
            className=" w-9 h-9 bg-[#2D2D2D] rounded-full flex flex-row justify-center items-center"
          >
            <img src={BackArrow} alt="" />
          </Link>
          <h2 className="text-xl font-medium text-white ml-6">
            Derma <span className="text-secondary">Ai</span>
          </h2>
          <div></div>
        </div>
      </div>

      <div className="circle-blur w-[80%] h-64 mx-auto mt-0 blur-[60px] absolute left-0 right-0"></div>

      <div className="px-6 w-full mx-auto relative z-50">
        <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
          <div className="bg-[#1D1D1D]/70 rounded-[20px] p-4">
            <h2 className="text-lg font-semibold text-secondary text-center mb-2 mt-2">
              Skin Scanner
            </h2>

            <p className="text-[13px] font-light text-white text-center leading-5 mb-3">
              Capture or upload a clear photo of your
              <br /> skin concern for AI-powered analysis and
              <br /> personalized recommendations.
            </p>

            <img src={SkinScaner} className="mx-auto" alt="" />

            <Link
              className="w-5/12 mx-auto rounded-full outline-none px-5 h-10 bg-white text-primary flex flex-row justify-center items-center mb-3 mt-3"
              to="/skin-analyzer"
            >
              Proceed
            </Link>
          </div>
        </AnimationOnScroll>
      </div>
      <div className="w-full px-6">
        <AnimationOnScroll animateIn="animate__fadeInUp" duration={0.65}>
          <div className="mt-4 p-5 rounded-[20px] bg-[#364560] text-white space-y-1.5">
            <h3 className="text-sm font-medium text-secondary">Disclaimer</h3>
            <p className="text-xxs text-justify font-light leading-4 text-white/80">
              For Investigational Use Only. Careplix is not a substitute for the
              clinical judgment of a health care professional. Careplix is
              intended to improve your awareness of general wellness. Careplix
              does not diagnose, treat, mitigate or prevent any disease,
              symptom, disorder or abnormal physical state. Consult with a
              health care professional or emergency services if you believe you
              may have a medical issue.
            </p>
          </div>
        </AnimationOnScroll>
      </div>

      {/* <Link to={-1} className="block mt-4 text-sm font-medium  text-white">
      Back
    </Link> */}
    </section>
  );
};

export default DermaStart;
